export var actionTypePrefix = '@@CommentThread';
export var commentOffsetParamName = 'comment';
// Default maximum depth of a thread before we show the "View X replies" button.
// Individual projects may use their own setting.
export var THREAD_MAX_DEPTH = 7;
// Threads in comment modals must display all comments regardless of how deep
// they are, in practice we can pass a very high number as a max depth.
export var COMMENT_MODAL_THREAD_MAX_DEPTH = 10000;
//# sourceMappingURL=constants.js.map